var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.615,
    height: 55.469,
    viewBox: "0 0 59.615 55.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-support-6834443",
    d: "M221.714,262.6v0h0a1.436,1.436,0,1,0,1.441,1.434A1.433,1.433,0,0,0,221.711,262.6Zm21.006,0v0a1.436,1.436,0,1,0,1.437,1.434A1.434,1.434,0,0,0,242.72,262.6Zm-16.285-4.059h0A1.434,1.434,0,0,0,225,259.979V268.1a1.437,1.437,0,0,0,2.875,0v-8.122a1.439,1.439,0,0,0-1.437-1.437Zm11.569,0v0h0a1.431,1.431,0,0,0-1.434,1.434V268.1a1.436,1.436,0,0,0,2.871,0v-8.122A1.436,1.436,0,0,0,238,258.541Zm-5.785-3.479h0a1.433,1.433,0,0,0-1.434,1.434V271.58a1.436,1.436,0,1,0,2.871,0V256.5A1.435,1.435,0,0,0,232.219,255.062Zm0-25.039v0h-.011a24.189,24.189,0,0,0-24.178,23.543h-1.321a4.3,4.3,0,0,0-4.3,4.266v13.406a4.3,4.3,0,0,0,4.3,4.266h5.806a4.3,4.3,0,0,0,4.3-4.266V257.836a4.3,4.3,0,0,0-4.3-4.266h-1.606a21.321,21.321,0,0,1,42.623,0h-1.61a4.3,4.3,0,0,0-4.3,4.266v13.406a4.351,4.351,0,0,0,.337,1.634v0a21.331,21.331,0,0,1-10.8,6.357,4.316,4.316,0,1,0,.358,2.871h0a24.213,24.213,0,0,0,12.388-7.1h0a4.359,4.359,0,0,0,2.014.5h5.806a4.3,4.3,0,0,0,4.3-4.266V257.835a4.3,4.3,0,0,0-4.3-4.266h-1.321a24.2,24.2,0,0,0-24.186-23.546Z",
    transform: "translate(-202.41 -230.023)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupport);
export default __webpack_public_path__ + "static/media/helpSupport.623f3e062eb6546870624b73435f6cf6.svg";
export { ForwardRef as ReactComponent };